import { render, staticRenderFns } from "./add-storage.vue?vue&type=template&id=55c67b78&"
import script from "./add-storage.vue?vue&type=script&lang=ts&"
export * from "./add-storage.vue?vue&type=script&lang=ts&"
import style0 from "./add-storage.vue?vue&type=style&index=0&id=55c67b78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports